import React from "react"

import ListItemImageShadow from "../../common/content-loading/ListItemImageShadow"
import ContentLines from "../../common/content-loading/ContentLines"
import ContentTags from "../../common/content-loading/ContentTags"

export default () => (
    <div className="list-group-item">
        <ListItemImageShadow />
        <div className="list-group-item-content">
            <ContentLines minLineLength={30} />
            <ContentLines />
            <ContentTags tags={1} />
            <div className="btn source-status shadow" />
        </div>
    </div>
)
